export function GalegoIcon(props: React.SVGAttributes<SVGSVGElement>) {
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<defs>
				<clipPath id="gal-clip">
					<rect width="16" height="16" rx="8" fill="white" />
				</clipPath>
				<path
					id="gal-cross"
					d="M0.325 0h-0.288v-0.325h-0.288v0.325h-0.325v0.288h0.325v0.325h0.288v-0.325h0.325z"
					fill="#CCC"
					stroke="black"
					strokeWidth="0.04"
				/>
			</defs>
			<g clipPath="url(#gal-clip)">
				<path d="M20 0H-4V16H20V0Z" fill="#F0F0F0" />
				<path d="M20 13.67L-0.56 0H-4V2.28L16.64 16H20V13.67Z" fill="#09C" />
				<path
					d="M7.86 12.21C5.46 12.21 5.54 9.95 5.54 9.95V6.47H10.19V9.95C10.19 9.95 10.27 12.21 7.86 12.21Z"
					fill="#005BBF"
					stroke="black"
					strokeWidth="0.04"
				/>
				<path
					d="M7.84 4.29C7.84 4.29 7.35 4.04 6.88 4.4C6.88 4.4 6.03 4.28 5.97 5.09C5.97 5.12 5.96 5.18 5.98 5.2C6 5.22 6.01 5.25 6.01 5.27C6.01 5.29 6.02 5.31 6.03 5.32C6.03 5.33 6.05 5.34 6.05 5.38C6.05 5.43 6.04 5.45 6.08 5.49C6.12 5.53 6.13 5.66 6.13 5.69C6.13 5.73 6.15 5.82 6.17 5.84C6.19 5.86 6.22 5.91 6.22 5.96C6.22 6 6.24 6.12 6.23 6.15C6.22 6.18 6.27 6.22 6.32 6.23C6.37 6.25 6.96 6.44 7.83 6.42C8.69 6.41 9 6.36 9.36 6.23C9.42 6.21 9.43 6.17 9.42 6.14C9.42 6.12 9.42 6.04 9.44 6.02C9.45 6 9.55 5.84 9.53 5.81C9.51 5.78 9.51 5.71 9.53 5.69C9.55 5.66 9.62 5.54 9.63 5.49C9.64 5.44 9.64 5.38 9.66 5.36C9.69 5.34 9.7 5.29 9.7 5.28C9.7 5.26 9.72 5.23 9.75 5.21C9.75 5.21 9.79 5.01 9.76 4.91C9.74 4.81 9.58 4.37 8.97 4.46C8.97 4.46 8.51 4.12 7.84 4.29"
					fill="#D81126"
					stroke="black"
					strokeWidth="0.06"
				/>
				<path
					d="M9.5 5.79C7.62 5.2 6.17 5.76 6.17 5.76C6.17 5.76 6.18 5.83 6.2 5.85C6.21 5.87 6.24 5.92 6.24 5.95C6.24 5.99 6.24 6.04 6.24 6.06C6.24 6.09 6.22 6.21 6.33 6.21C6.33 6.21 7.64 5.69 9.34 6.23C9.34 6.23 9.39 6.19 9.39 6.13C9.39 6.07 9.4 6.01 9.43 5.98C9.45 5.94 9.5 5.84 9.5 5.79"
					fill="#BCAC0B"
				/>
				<path
					d="M7.76 8.93H6.94C6.94 8.93 6.86 9.66 7.49 9.88V9.95H7.62V10.04C7.62 10.04 7.39 10.25 7.59 10.49V10.56H7.63V10.68H7.66V10.87C7.66 10.87 7.63 11.55 6.97 11.88V11.92H8.75V11.88C8.08 11.55 8.05 10.87 8.05 10.87V10.68H8.09V10.56H8.12V10.49C8.32 10.25 8.09 10.04 8.09 10.04V9.95H8.23V9.88C8.86 9.66 8.78 8.93 8.78 8.93H7.76Z"
					fill="#C8B100"
					fillOpacity="0.94"
					stroke="black"
					strokeWidth="0.04"
				/>
				<path
					d="M7.46 9.87H8.25M7.49 9.94H8.22M7.62 10.04H8.08M7.59 10.49H8.12M7.63 10.55H8.09M7.63 10.66H8.09M7.34 11.59H8.37M7.06 11.83H8.66M7 11.86H8.72"
					stroke="black"
					strokeWidth="0.01"
				/>
				<circle cx="7.87" cy="8.37" r="0.52" fill="#CCC" stroke="black" strokeWidth="0.04" />
				<use href="#gal-cross" x="6.18" y="7.5" />
				<use href="#gal-cross" x="9.56" y="7.5" />
				<use href="#gal-cross" x="7.85" y="7.09" />
				<use href="#gal-cross" x="6.18" y="8.91" />
				<use href="#gal-cross" x="9.56" y="8.91" />
				<use href="#gal-cross" x="6.18" y="10.33" />
				<use href="#gal-cross" x="9.56" y="10.33" />
				<circle cx="7.86" cy="3.28" r="0.31" fill="#005BBF" stroke="black" strokeWidth="0.04" />
				<path
					d="M8.15 3.22H7.89V2.81H7.99V2.72H7.89V2.63H7.81V2.72H7.71V2.81H7.81V3.22H7.57V3.28H7.81V3.28H7.89V3.28H8.15V3.22Z"
					fill="#BCAC0B"
					stroke="black"
					strokeWidth="0.02"
				/>
				<path
					d="M6.61 3.96C6.61 3.96 6.84 3.94 6.97 3.99C6.97 3.99 6.82 4.17 6.85 4.4C6.87 4.51 6.89 4.57 6.93 4.63C6.96 4.69 7 4.81 6.98 4.9H7.02C7.02 4.9 7.06 4.71 6.99 4.6C6.92 4.49 6.88 4.35 6.95 4.19C7.03 4.04 7.13 3.98 7.13 3.98C7.26 4.03 7.52 3.98 7.59 3.93C7.67 3.87 7.7 3.8 7.57 3.79C7.43 3.79 7.19 3.79 7.03 3.91C7.03 3.91 6.95 3.81 6.53 3.86C6.11 3.91 5.81 4.09 5.71 4.46C5.67 4.65 5.85 5.06 6.01 5.15C6.01 5.15 6 5.09 6.02 5.04C6.02 5.04 5.74 4.73 5.83 4.44C5.91 4.14 6.24 3.95 6.61 3.96Z"
					fill="#BCAC0B"
					stroke="black"
					strokeWidth="0.03"
				/>
				<path
					d="M9.11 3.99C9.11 3.99 8.87 3.96 8.74 4.02C8.74 4.02 8.89 4.19 8.86 4.42C8.84 4.54 8.82 4.6 8.79 4.66C8.75 4.71 8.72 4.83 8.74 4.92H8.69C8.69 4.92 8.65 4.73 8.72 4.63C8.8 4.52 8.83 4.37 8.76 4.22C8.69 4.06 8.58 4 8.58 4C8.46 4.05 8.19 4.01 8.12 3.95C8.05 3.9 8.01 3.82 8.15 3.82C8.28 3.81 8.52 3.81 8.68 3.94C8.68 3.94 8.76 3.84 9.18 3.88C9.6 3.93 9.91 4.11 10 4.49C10.05 4.68 9.87 5.08 9.7 5.18C9.7 5.18 9.71 5.11 9.69 5.07C9.69 5.07 9.97 4.75 9.89 4.46C9.8 4.17 9.47 3.98 9.11 3.99Z"
					fill="#BCAC0B"
					stroke="black"
					strokeWidth="0.03"
				/>
				<path
					d="M7.64 3.73V4.62C7.63 4.71 7.75 4.84 7.83 4.87C7.83 4.87 8.03 4.81 8.04 4.62V3.68H7.98V4.5C7.97 4.58 7.92 4.73 7.85 4.76C7.85 4.76 7.7 4.73 7.69 4.5V3.71L7.64 3.73Z"
					fill="#BCAC0B"
					stroke="black"
					strokeWidth="0.03"
				/>
				<circle cx="5.67" cy="4.85" r="0.1" fill="#F0F0F0" stroke="black" strokeWidth="0.04" />
				<circle cx="5.6" cy="4.6" r="0.1" fill="#F0F0F0" stroke="black" strokeWidth="0.04" />
				<circle cx="5.64" cy="4.3" r="0.1" fill="#F0F0F0" stroke="black" strokeWidth="0.04" />
				<circle cx="5.81" cy="4.06" r="0.1" fill="#F0F0F0" stroke="black" strokeWidth="0.04" />
				<circle cx="6" cy="3.88" r="0.1" fill="#F0F0F0" stroke="black" strokeWidth="0.04" />
				<circle cx="6.25" cy="3.78" r="0.1" fill="#F0F0F0" stroke="black" strokeWidth="0.04" />
				<circle cx="6.52" cy="3.73" r="0.1" fill="#F0F0F0" stroke="black" strokeWidth="0.04" />
				<circle cx="6.77" cy="3.71" r="0.1" fill="#F0F0F0" stroke="black" strokeWidth="0.04" />
				<circle cx="6.99" cy="3.73" r="0.1" fill="#F0F0F0" stroke="black" strokeWidth="0.04" />
				<circle cx="7.64" cy="3.65" r="0.1" fill="#F0F0F0" stroke="black" strokeWidth="0.04" />
				<circle cx="7.84" cy="3.71" r="0.1" fill="#F0F0F0" stroke="black" strokeWidth="0.04" />
				<circle cx="7.84" cy="4.5" r="0.1" fill="#F0F0F0" stroke="black" strokeWidth="0.04" />
				<circle cx="10.05" cy="4.91" r="0.1" fill="#F0F0F0" stroke="black" strokeWidth="0.04" />
				<circle cx="10.11" cy="4.65" r="0.1" fill="#F0F0F0" stroke="black" strokeWidth="0.04" />
				<circle cx="10.06" cy="4.37" r="0.1" fill="#F0F0F0" stroke="black" strokeWidth="0.04" />
				<circle cx="9.95" cy="4.11" r="0.1" fill="#F0F0F0" stroke="black" strokeWidth="0.04" />
				<circle cx="9.75" cy="3.93" r="0.1" fill="#F0F0F0" stroke="black" strokeWidth="0.04" />
				<circle cx="9.51" cy="3.81" r="0.1" fill="#F0F0F0" stroke="black" strokeWidth="0.04" />
				<circle cx="9.24" cy="3.75" r="0.1" fill="#F0F0F0" stroke="black" strokeWidth="0.04" />
				<circle cx="9" cy="3.73" r="0.1" fill="#F0F0F0" stroke="black" strokeWidth="0.04" />
				<circle cx="8.77" cy="3.7" r="0.1" fill="#F0F0F0" stroke="black" strokeWidth="0.04" />
				<circle cx="8.92" cy="4.58" r="0.1" fill="#F0F0F0" stroke="black" strokeWidth="0.04" />
				<circle cx="8.97" cy="4.37" r="0.1" fill="#F0F0F0" stroke="black" strokeWidth="0.04" />
				<circle cx="8.08" cy="3.69" r="0.1" fill="#F0F0F0" stroke="black" strokeWidth="0.04" />
				<circle cx="7.56" cy="3.66" r="0.1" fill="#F0F0F0" stroke="black" strokeWidth="0.04" />
				<circle cx="7.43" cy="3.65" r="0.1" fill="#F0F0F0" stroke="black" strokeWidth="0.04" />
				<circle cx="6.75" cy="4.58" r="0.1" fill="#F0F0F0" stroke="black" strokeWidth="0.04" />
				<circle cx="6.72" cy="4.32" r="0.1" fill="#F0F0F0" stroke="black" strokeWidth="0.04" />
				<circle cx="6.79" cy="4.08" r="0.1" fill="#F0F0F0" stroke="black" strokeWidth="0.04" />
				<circle cx="7.27" cy="3.68" r="0.1" fill="#F0F0F0" stroke="black" strokeWidth="0.04" />
				<circle cx="7.09" cy="3.75" r="0.1" fill="#F0F0F0" stroke="black" strokeWidth="0.04" />
				<circle cx="6.92" cy="3.89" r="0.1" fill="#F0F0F0" stroke="black" strokeWidth="0.04" />
				<circle cx="7.84" cy="3.83" r="0.1" fill="#F0F0F0" stroke="black" strokeWidth="0.04" />
				<circle cx="7.84" cy="4.03" r="0.1" fill="#F0F0F0" stroke="black" strokeWidth="0.04" />
				<circle cx="7.84" cy="4.25" r="0.1" fill="#F0F0F0" stroke="black" strokeWidth="0.04" />
				<circle cx="8.22" cy="3.66" r="0.1" fill="#F0F0F0" stroke="black" strokeWidth="0.04" />
				<path d="M7.84 5.67L7.69 5.75L7.82 5.83L7.98 5.75L7.84 5.67Z" fill="#F00" stroke="black" strokeWidth="0.02" />
				<path d="M6.29 6.22C6.29 6.22 7.64 5.69 9.34 6.23" stroke="black" strokeWidth="0.06" />
				<path d="M9.53 5.8C7.65 5.21 6.15 5.77 6.15 5.77" stroke="black" strokeWidth="0.02" />
			</g>
		</svg>
	);
}
